import { gql } from '@apollo/client';

import { GRAPHQL } from '../../../../../cms/constants';
import awardFields from '../../../../../cms/fragments/award-fields';
import commonQuestionsFields from '../../../../../cms/fragments/common-questions-fields';
import explainedTermFields from '../../../../../cms/fragments/explained-term-fields';
import howToFields from '../../../../../cms/fragments/how-to-fields';
import productListFields from '../../../../../cms/fragments/product-list-fields';
import sellingPointFields from '../../../../../cms/fragments/selling-point-fields';
import topicGroupFields from '../../../../../cms/fragments/topic-group-fields';
import valuePropositionFields from '../../../../../cms/fragments/value-proposition-fields';

// eslint-disable-next-line import/prefer-default-export
const GET_EXPLAINED_TERM = gql`
  query getExplainedTerm($slug: String) {
    allExplainedTerm(
      where: { identifier: { current: { eq: $slug } } }
    ) {
      ...explainedTermFields
      metadataObject {
        name
        descriptionRaw
      }
      refersToContent {
        ... on ProductList {
          ...productListFields
        }
        ... on Award {
          ...awardFields
        }
        ... on HowTo {
          ...howToFields
        }
        ... on ValuePropositionsObject {
          title
          valuePropositionsReference {
            ...valuePropositionFields
          }
          ${GRAPHQL.URL_OBJECT}
        }
        ... on CommonQuestions {
          ...commonQuestionsFields
        }
        ... on RelatedTopicsUrl {
          ${GRAPHQL.URL_OBJECTS}
        }
        ... on SellingPointGroup {
          ...sellingPointFields
        }
        ... on TopicGroup {
          ...topicGroupFields
        }
        ... on ContentTiles {
          tiles {
            ... on ExplainedTerm {
              ...explainedTermFields
              ${GRAPHQL.CONTENT_TILE_FIELDS}
            }
            ... on Service {
              ${GRAPHQL.CONTENT_TILE_FIELDS}
              ${GRAPHQL.IMAGE_OBJECT}
            }
          }
        }
      }
    }
  }
  ${awardFields}
  ${commonQuestionsFields}
  ${explainedTermFields}
  ${howToFields}
  ${sellingPointFields}
  ${topicGroupFields}
  ${valuePropositionFields}
  ${productListFields}
`;

export default GET_EXPLAINED_TERM;
